@use '../../style/mixins.scss';
@use '../../style/functions.scss';
@import '../../../node_modules/prismjs/plugins/toolbar/prism-toolbar.css';

:host {
    display: flex;
    font-size: 1rem;
}

slot {
    display: none;
}

.root {
    width: 100%;
}

div.code-toolbar {
    z-index: 1; // puts it over the gradient effect of kompendium-code
    display: flex;
    height: 100%;

    > .toolbar {
        padding-right: functions.pxToRem(4);

        .toolbar-item {
            button,
            span {
                all: unset; // resets Prism's messy CSS
            }
            button {
                cursor: pointer;
                @include mixins.is-elevated-clickable();

                background-color: rgb(var(--kompendium-contrast-100));
                color: rgb(var(--kompendium-contrast-1100));
                padding: functions.pxToRem(2) functions.pxToRem(8);
                border-radius: functions.pxToRem(6);
                font-size: functions.pxToRem(12);
            }
        }
    }
}

/* PrismJS 1.19.0
https://prismjs.com/download.html#themes=prism-tomorrow&languages=markup+css+clike+javascript+less+jsx+tsx+scss+typescript */
/**
 * prism.js tomorrow night eighties for JavaScript, CoffeeScript, CSS and HTML
 * Based on https://github.com/chriskempson/tomorrow-theme
 * @author Rose Pritchard
 */
code,
pre {
    font-family: var(--kompendium-font-code);
    font-size: functions.pxToRem(13);
}
code[class*='language-'],
pre[class*='language-'] {
    color: rgb(var(--kompendium-color-code-gray-lighter));
    background: none;
    text-align: left;
    white-space: pre;
    word-spacing: normal;
    word-break: normal;
    word-wrap: normal;
    line-height: normal;

    -moz-tab-size: 4;
    -o-tab-size: 4;
    tab-size: 4;

    -webkit-hyphens: none;
    -moz-hyphens: none;
    -ms-hyphens: none;
    hyphens: none;
}

/* Code blocks */
pre[class*='language-'] {
    padding: functions.pxToRem(24) functions.pxToRem(16) functions.pxToRem(32)
        functions.pxToRem(16);
    position: relative;
    margin: 0;
    overflow: auto;
    flex-grow: 1;
    border-radius: functions.pxToRem(9);
}

:not(pre) > code[class*='language-'],
pre[class*='language-'] {
    background: rgb(var(--kompendium-color-code-background));
}

/* Inline code */
:not(pre) > code[class*='language-'] {
    white-space: normal;
}

.token.comment {
    color: var(--kompendium-color-code-gray-light);
}

.token.block-comment,
.token.prolog,
.token.doctype,
.token.cdata {
    color: var(--kompendium-color-code-gray-lighter);
}

.token.punctuation {
    color: var(--kompendium-color-code-gray-dark);
}

.token.tag,
.token.attr-name,
.token.namespace,
.token.deleted {
    color: rgb(var(--kompendium-color-code-pink));
}

.token.function-name {
    color: rgb(var(--kompendium-color-code-blue));
}

.token.boolean,
.token.number,
.token.function {
    color: rgb(var(--kompendium-color-code-orange));
}

.token.property,
.token.class-name,
.token.constant,
.token.symbol {
    color: rgb(var(--kompendium-color-code-yellow));
}

.token.selector,
.token.important,
.token.atrule,
.token.keyword,
.token.builtin {
    color: rgb(var(--kompendium-color-code-purple));
}

.token.string,
.token.char,
.token.attr-value,
.token.regex,
.token.variable {
    color: rgb(var(--kompendium-color-code-green-light));
}

.token.operator {
    color: rgb(var(--kompendium-color-code-purple));
}

.token.entity,
.token.url {
    color: rgb(var(--kompendium-color-code-turquoise));
}

.token.important,
.token.bold {
    font-weight: bold;
}
.token.italic {
    font-style: italic;
}

.token.entity {
    cursor: help;
}

.token.inserted {
    color: rgb(var(--kompendium-color-code-green-dark));
}
